import Cookies from 'js-cookie';
import Config from '@/config/config';

export const removeAccessToken = (): void => {
  Cookies.remove(Config.ACCESS_TOKEN_KEY);
};

export const getAccessToken = (): string | undefined => {
  const accessToken = Cookies.get(Config.ACCESS_TOKEN_KEY);
  return accessToken;
};

